const path = require("path");

export const Path = {
  parent: (pathStr: string) => {
    return path.dirname(pathStr);
  },
  name: (pathStr: string) => {
    path.basename(pathStr);
  },
};
